export default __webpack_public_path__ + "static/media/telemarketinghelp-export-mobile.ab15853d.PNG";